<div class="form">
    <form *ngIf="form" (ngSubmit)="save()" matForm [formGroup]="form">

        <div *ngIf="showDetails()">
            <div class="historyPanel mat-small">
                <div *ngIf="site.createdDate">
                    <strong>created</strong> {{ site.createdDate | date: 'MMM d, YYYY, h:mm:ss a' }}
                    <span *ngIf="site.createdByUserName"><br />by {{ site.createdByUserName }}</span>
                </div>
                <div *ngIf="site.modifiedDate > site.createdDate">
                    <strong>modified</strong> {{ site.modifiedDate | date: 'MMM d, YYYY, h:mm:ss a' }}
                    <span *ngIf="site.modifiedByUserName"><br />by {{ site.modifiedByUserName }}</span>
                </div>
            </div>
            <div class="control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Site Name</mat-label>
                    <input matInput placeholder="Name" formControlName="name" required>
                </mat-form-field>
            </div>
            <div class="control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Description</mat-label>
                    <textarea matInput maxlength="500" formControlName="description"></textarea>
                </mat-form-field>
            </div>
            <div class="control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>BDR/Memo Number and Title:</mat-label>
                    <textarea rows="5"
                              matInput
                              placeholder="Number—title (date exactly as it appears on the BDR) e.g. 'BDR 24-41—Government-wide Tracking of Resources for Cyber Activities and Cyber Workforce (9/16/2024)'"
                              formControlName="purpose">
                    </textarea>
                </mat-form-field>
            </div>
            <div class="control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Frequency</mat-label>
                    <mat-select formControlName="frequency">
                        <mat-option *ngFor="let f of frequencyOfCollection" [value]="f">
                            {{f}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="control-wrapper">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Site Point of Contact</mat-label>
                    <input matInput formControlName="maxPointOfContact" [matAutocomplete]="pickerItemPOC">
                    <mat-autocomplete #pickerItemPOC [panelWidth]="300" [displayWith]="pickerDisplayFn">
                        <mat-option *ngFor="let pi of pocPickerItems | async" [value]="pi">
                            <span title="{{pi.fullDisplay}}">{{pi.fullDisplay}}</span>
                        </mat-option>
                    </mat-autocomplete>
                    <div class="loading">
                        <span>
                            <mat-spinner *ngIf="showLoadingIndicator" diameter="25" style="top: -10px;"></mat-spinner>
                        </span>
                    </div>
                </mat-form-field>
            </div>

        </div>

        <div class="button-wrapper">
            <button type="button" mat-raised-button color="primary" (click)="save()" (keyup.enter)="save()" [disabled]="!(form.valid && form.dirty)">Save</button>
            <button type="button" *ngIf="!form.dirty" mat-raised-button (click)="cancel()" (keyup.enter)="cancel()">Cancel</button>
            <button type="button" *ngIf="form.dirty" mat-raised-button (click)="reset()" (keyup.enter)="reset()">Reset</button>
        </div>
    </form>
</div>
